import { type Observable } from 'rxjs';
import {
  type IManagementResource,
  type ManagementResource,
} from './management-resource';

export interface IToolRunContext<T = unknown> {
  resource?: IResourceContext<T>;
}

export interface IManagementTool<T = unknown> {
  name: string;
  label: string;
  icon: string;
  description?: string;
  resource?: ManagementResource;
  isDisabled?: (context: IToolRunContext<T>) => Observable<boolean>;
  isHidden?: (context: IToolRunContext<T>) => Promise<boolean>;
  run: (context: IToolRunContext<T>) => void | Promise<void>;
}

export interface IToolListItem {
  tool: IManagementTool;
  matchingResource?: IResourceContext<unknown>;
  disabled$: Observable<boolean>;
  hidden: boolean;
}

export interface IResourceToolGroup<T = unknown> {
  resource?: IResourceContext<T>;
  resolvedLabel$: Observable<string>;
  tools: IToolListItem[];
}

export interface IResourceContext<T = unknown> {
  resource: IManagementResource;
  routeDataKey: string;
  label$: Observable<string>;
  value$: Observable<T>;
}
